__turbopack_context__.v({
  "arrow": "style-module-scss-module__vVel8G__arrow",
  "card": "style-module-scss-module__vVel8G__card",
  "cardDescription": "style-module-scss-module__vVel8G__cardDescription",
  "cardHeader": "style-module-scss-module__vVel8G__cardHeader",
  "cardMedia": "style-module-scss-module__vVel8G__cardMedia",
  "cardNumber": "style-module-scss-module__vVel8G__cardNumber",
  "cardTitle": "style-module-scss-module__vVel8G__cardTitle",
  "cardsTrack": "style-module-scss-module__vVel8G__cardsTrack",
  "even": "style-module-scss-module__vVel8G__even",
  "footer": "style-module-scss-module__vVel8G__footer",
  "footerLink": "style-module-scss-module__vVel8G__footerLink",
  "hidden": "style-module-scss-module__vVel8G__hidden",
  "horizontalScroll": "style-module-scss-module__vVel8G__horizontalScroll",
  "logo": "style-module-scss-module__vVel8G__logo",
  "section": "style-module-scss-module__vVel8G__section",
  "stickyContainer": "style-module-scss-module__vVel8G__stickyContainer",
});
